import React from 'react';
import { PropTypes } from 'react-desc';
import styled from 'styled-components';
import { focus } from '@elliemae/ds-system';

var Button = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-15udc15-0"
})(["all:unset;position:absolute;height:calc(100% - 2px);width:28px;top:1px;right:1px;display:flex;justify-content:center;align-items:center;box-sizing:border-box;cursor:pointer;z-index:1;svg{fill:", ";}&:disabled{color:#5d6775;cursor:not-allowed;svg{fill:#5d6775;}}&:focus{", "}"], function (props) {
  return props.theme.colors.brand['600'];
}, focus());

var SButton = function SButton(_ref) {
  var icon = _ref.icon,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    "data-testid": "ds-searchbox-button",
    onClick: onClick,
    disabled: disabled,
    type: "button"
  }, icon);
};

SButton.propTypes = {
  /** click handler for button */
  onClick: PropTypes.func.isRequired.description('click handler for button'),

  /** ds icon to render inside button */
  icon: PropTypes.node.isRequired.description('ds icon to render inside button'),

  /** disable button */
  disabled: PropTypes.bool.description('disable button')
};

export { SButton };
//# sourceMappingURL=SButton.js.map
